import React from "react";
import { RestrictionAlert } from "@/features/reserve/components/RestrictionAlert/RestrictionAlert";
import { useReserveForm } from "@/features/reserve/components/Reserve/ReserveFormProvider";
import { cn } from "@gettactic/helpers";

export interface ReserveFormRestrictionAlertsProps {
  className?: string;
}

export const ReserveFormRestrictionAlerts: React.FC<
  ReserveFormRestrictionAlertsProps
> = ({ className }) => {
  const { officeAvailabilityErrors } = useReserveForm();

  if (!officeAvailabilityErrors.length) return null;

  return (
    <RestrictionAlert
      availabilityErrors={officeAvailabilityErrors}
      className={cn("mb-2 max-w-xl", className)}
    />
  );
};
